import { createStore } from 'vuex'

export default createStore({
  state: {
    locale: 'en', // Default language
    ledgers: {
      types: []
    },
    branch: {
      branch_abbr: null,
      branch_code: null,
      branch_name: null,
      kiosk_id: null,
      session_id: null,
      device_id: null,
    },
    user_agent: {
      device: {
        model: null,
        type: null,
        vendor: null,
      },
    },
    login_params: {
      hash: null,
      value: null,
      uuid: null,
      type: null,
    },
    user: {
      old_pin: null,
      is_logged_in: null,
      pso_enroll: null,
      pin_update: null,
      key: null,
      uuid: null,
      hash: null,
      email: null,
      mobile: null,
      account_number: null,
      serial_number: null,
      first_name: null,
      middle_name: null,
      last_name: null,
      tin: null,
      qr: null,
      balance_ref: null,
      birthdate: null,
      type: null,
      ledgers: [],
      hasAgreedToPrivacyMobile: false,
      hasAgreedToPrivacyEmail: false,
      hasAgreedToPrivacyBirthday: false,
      hasAgreedToPrivacyTIN: false,
      hasAgreedToPrivacyPIN: false,
    },
    pin_enrollment: {
      uuid: null,
      hash: null,
      mobile: null,
      email: null,
      name: null,
      account: null,
      account_type: null,
      otp_token: null,
      otp_pin: null,
    },
  },
  mutations: {
    setLanguage(state, lang) {
      state.locale = lang;
    },
    updateHasAgreedToPrivacy(state, { field, value }) {
      state.user[field] = value;
    },
    setLoginParams(state, params) {
      state.login_params.hash = params.hash;
      state.login_params.value = params.value;
      state.login_params.uuid = params.uuid;
      state.login_params.type = params.type;
    },
    appendToSL(state, payload) {
      if (Array.isArray(state.ledgers.types)) {
        state.ledgers.types.push(...payload);
      } else {
        state.ledgers.types = payload;
      }
    },
    addBalance(state, { code, name, balance, records, as_of }) {
      const ledger = state.user.ledgers.find((item) => item.code === code);
      if (ledger) {
        ledger.balance = balance;
      } else {
        state.user.ledgers.push({ code: code, name: name, balance: balance, records: records, as_of: as_of, transactions: [] });
      }
    },
    addTransaction(state, { code, transactions, timestamp, is_retrieved }) {
      const ledger = state.user.ledgers.find((item) => item.code === code);
      if (ledger) {
        ledger.transactions.push(...transactions);
        ledger.timestamp = timestamp;
        ledger.is_retrieved = is_retrieved;
      }
    },
    updateEmail(state, email) {
      state.user.email = email;
    },
    updateMobile(state, mobile) {
      state.user.mobile = mobile;
    },
    updateTIN(state, tin) {
      state.user.tin = tin;
    },
    updateBirthdate(state, birthdate) {
      state.user.birthdate = birthdate;
    },
  },
})